import { propEq, remove } from 'ramda'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Grid } from '../../../packages/kiti/components/structure/Grid'
import { hasValue } from '../../../utils/helpers/value'
import DynamicPresentationText from '../DynamicPresentationText'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { useAlert } from '@btime/react-messager'
import DataTable from './table/DataTable'
import Text from '../../../packages/kiti/components/presentation/Text'

const DynamicBlockTable = ({ value, blockQuestions, onSelect, onEdit, onChange }) => {
  const modal = useAlert()
  const { t } = useTranslation('common')
  if (!hasValue(value)) return false

  const columns = [
    {
      label: '#',
      flex: 0,
      minWidth: 1.5,
      render: (_, __, index) => (
        <Text size="xxsmall" bold>
          {index + 1}
        </Text>
      )
    },

    ...blockQuestions.map(question => ({
      label: question.name,
      minWidth: question.type.name === 'stock' ? 10 : 4,
      render: (_, replies) => {
        const v = replies.find(propEq('questionId', question.id))?.value
        return <DynamicPresentationText value={v} type={question.type.name} truncate={35} />
      }
    })),

    {
      label: t('actions'),
      flex: 0,
      minWidth: 3.5,
      render: (_, __, index) => (
        <Grid align="center" justify="center" gap={0.5}>
          {onSelect && <Icon name="BsSearch" color="dark3" size={0.875} onClick={() => onSelect(index)} />}
          {onEdit && <Icon name="BsFillPencilFill" color="dark3" size={0.875} onClick={() => onEdit(index)} />}

          {onChange && (
            <Icon
              name="BsTrash"
              color="red"
              size={0.875}
              onClick={() => {
                if (modal.confirm({ title: t('widgets.removeScreenItem.confirm') })) {
                  onChange(remove(index, 1, value))
                }
              }}
            />
          )}
        </Grid>
      )
    }
  ]

  return (
    <>
      <DataTable columns={columns} data={value} />
      <Separator weight={4} />
    </>
  )
}

export default DynamicBlockTable
